(function () {
  'use strict';
  if (window.YK_CART_SESSION) return;
  var OWNER = 'yk_cart_owner';
  var BACKUP = 'yk_buy_now_previous_cart';
  var readyPhone = '';
  var inFlight = null;
  var oldProof = null;
  try { oldProof = JSON.parse(localStorage.getItem('yk_otp_verified') || 'null'); } catch (e) {}
  try {
    if (!localStorage.getItem(OWNER) && oldProof && oldProof.phone) localStorage.setItem(OWNER, oldProof.phone);
  } catch (e) {}
  function phone() {
    return window.YK_OTP && window.YK_OTP.isVerified() || '';
  }
  function cartUrl(path) {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/' + path;
  }
  function json(url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    });
  }
  function clear() {
    return json(cartUrl('clear.js'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' });
  }
  function restore(previous, currentPhone) {
    if (!previous || previous.phone !== currentPhone) return Promise.resolve();
    return clear().then(function () {
      if (!previous.items.length) return;
      return json(cartUrl('add.js'), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: previous.items })
      });
    }).then(function () {
      if (!previous.note && !Object.keys(previous.attributes || {}).length) return;
      return json(cartUrl('update.js'), {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: previous.note || '', attributes: previous.attributes || {} })
      });
    }).then(function () {
      try { sessionStorage.removeItem(BACKUP); } catch (e) {}
    });
  }
  function ready() {
    var current = phone();
    if (!current) return Promise.reject(new Error('Login required'));
    if (readyPhone === current && !inFlight) return Promise.resolve();
    if (inFlight) return inFlight;
    inFlight = Promise.resolve().then(function () {
      var owner = '';
      try { owner = localStorage.getItem(OWNER) || ''; } catch (e) {}
      if (owner !== current) {
        try { sessionStorage.removeItem(BACKUP); } catch (e) {}
        return clear();
      }
    }).then(function () {
      try { localStorage.setItem(OWNER, current); } catch (e) {}
      var previous = null;
      try { previous = JSON.parse(sessionStorage.getItem(BACKUP) || 'null'); } catch (e) {}
      return restore(previous, current);
    }).then(function () {
      readyPhone = current;
      document.documentElement.classList.add('yk-cart-ready');
    }).finally(function () { inFlight = null; });
    return inFlight;
  }
  function checkoutSingle(url) {
    return ready().then(function () { return json((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js'); }).then(function (cart) {
      var current = phone();
      if (!current) throw new Error('Login required');
      var items = (cart.items || []).map(function (item) {
        var line = { id: item.variant_id, quantity: item.quantity };
        if (item.properties && Object.keys(item.properties).length) line.properties = item.properties;
        if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) line.selling_plan = item.selling_plan_allocation.selling_plan.id;
        return line;
      });
      try {
        sessionStorage.setItem(BACKUP, JSON.stringify({ phone: current, items: items, note: cart.note, attributes: cart.attributes }));
      } catch (e) { throw new Error('Could not preserve your cart'); }
      return clear();
    }).then(function () {
      document.documentElement.classList.remove('yk-cart-ready');
      window.location.assign(url);
    });
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var url;
    try { url = new URL(link.href, location.href); } catch (e) { return; }
    if (url.origin !== location.origin || url.pathname.replace(/\/$/, '') !== '/cart') return;
    if (phone()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (window.YK_OTP) window.YK_OTP.open({ onVerified: function () {
      window.YK_OTP.close();
      ready().then(function () { location.assign(link.href); });
    } });
  }, true);
  document.addEventListener('yk:otp-verified', function () { ready().catch(function () {}); });
  window.YK_CART_SESSION = { ready: ready, checkoutSingle: checkoutSingle, canUse: function () { return readyPhone === phone(); } };
  if (phone()) ready().catch(function () {});
  if (location.pathname.replace(/\/$/, '') === '/cart' && !phone()) {
    function promptCart() {
      if (!window.YK_OTP) return;
      window.YK_OTP.open({ onVerified: function () {
        window.YK_OTP.close();
        ready().then(function () { location.reload(); });
      } });
      var ov = document.querySelector('.ykotp-ov');
      if (ov) new MutationObserver(function (records, watcher) {
        if (!ov.classList.contains('on') && !phone()) {
          watcher.disconnect();
          location.replace('/');
        }
      }).observe(ov, { attributes: true, attributeFilter: ['class'] });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', promptCart);
    else promptCart();
  }
  function refreshVisibility() {
    if (!phone()) {
      readyPhone = '';
      document.documentElement.classList.remove('yk-cart-ready');
    }
  }
  document.addEventListener('visibilitychange', refreshVisibility);
  setInterval(refreshVisibility, 60000);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted && phone()) { readyPhone = ''; ready().catch(function () {}); }
  });
})();